import React, { useContext, useMemo } from "react";
import { SimpleGrid, Heading, Button, Box } from "@chakra-ui/core";

import FoodCard from "components/food/FoodCard";

import { formatPrice } from "utils/shared/prices";
import slugify from "utils/shared/slugify";
import numberify from "utils/shared/numberify";
import sortFoodsByPosition from "utils/shared/sortFoodsByPosition";
import { ContextStore } from "context/ContextStore";

function FoodMenu({ foods, sectionsRef, categories }) {
  const { setOpenFood, basketOrders, setModalOpen, timeNow } = useContext(ContextStore);

  const handleOpen = (foodToSet) => {
    setOpenFood(JSON.parse(JSON.stringify({ ...foodToSet }))); // JSON thingy to make a deep copy
    setModalOpen(true);
  };

  const countAmountInBasket = (array, myTarget) => {
    var count = 0;
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === myTarget) {
        count++;
      }
    }
    return count;
  };

  return (
    <Box>
      {foods.map(([sectionName, foods], i) => {
        let catHoraires = {};
        catHoraires.openAM = categories.find((c) => c.name === sectionName).openAM;
        catHoraires.closeAM = categories.find((c) => c.name === sectionName).closeAM;
        catHoraires.openPM = categories.find((c) => c.name === sectionName).openPM;
        catHoraires.closePM = categories.find((c) => c.name === sectionName).closePM;

        const childrenSize = useMemo(() => {
          const defaultChildrenSize = "lg";
          const categoryChildrenSize = categories.find((c) => c.name === sectionName).childrenSize;
          return categoryChildrenSize ? categoryChildrenSize : defaultChildrenSize;
        }, [categories, sectionName]);

        const gridColumns = useMemo(() => {
          switch (childrenSize) {
            case "sm":
              return { sm: 1, md: 2, lg: 3 };
            case "md":
              return { sm: 1, md: 2, lg: 3 };
            case "lg":
              return { base: 1, sm: 2, md: 3, lg: 4, xl: 5 };
            default:
              return { sm: 1, md: 2, lg: 3 };
          }
        }, [childrenSize]);

        // TODO: use useMemo where necessary to re-render only when needed.

        const hasCatHoraires =
          catHoraires.openAM.length !== 0 &&
          catHoraires.closeAM.length !== 0 &&
          catHoraires.openPM.length !== 0 &&
          catHoraires.closePM.length !== 0;

        const disponibleHeadingText = `Disponible de ${catHoraires.openAM}
        ${catHoraires.openAM && catHoraires.closeAM && " à "}
        ${catHoraires.closeAM}
        ${catHoraires.closeAM && catHoraires.openPM && " et "} ${catHoraires.openPM}
        ${catHoraires.openPM && catHoraires.closePM && " à "}
        ${catHoraires.closePM}`;

        let isCategoryAvailable;

        if (
          (numberify(timeNow) > numberify(catHoraires.openAM) && numberify(timeNow) < numberify(catHoraires.closeAM)) ||
          (numberify(timeNow) > numberify(catHoraires.openPM) &&
            numberify(timeNow) < numberify(catHoraires.closePM === "00:00" ? "24:00" : catHoraires.closePM))
        ) {
          isCategoryAvailable = true;
        } else {
          if (hasCatHoraires && timeNow) {
            isCategoryAvailable = process.env.NODE_ENV === "development" ? true : false;
          } else {
            isCategoryAvailable = true;
          }
        }

        return (
          <Box key={i} pt={i === 0 ? "12" : "16"} mb="-4px" id={slugify(sectionName)} ref={sectionsRef[i]}>
            <Heading mt="4" mb={hasCatHoraires ? "2" : "4"} as="h3" size="lg" key={"H-" + sectionName}>
              {sectionName}
            </Heading>
            {hasCatHoraires && (
              <Heading mb="4" as="h4" size="sm" fontWeight="semibold" color="gray.600">
                {disponibleHeadingText}
              </Heading>
            )}

            <SimpleGrid
              key={"G-" + sectionName}
              columns={gridColumns}
              spacing={{ base: "10px", sm: "20px", md: "20px" }}
            >
              {sortFoodsByPosition(foods).map((food, i) => {
                if (food.isAvailable) {
                  food.isAvailable = isCategoryAvailable;
                }
                return (
                  <FoodCard
                    size={childrenSize}
                    badgeText={food.badgeText}
                    image={food.image}
                    key={food.name + i}
                    name={food.name}
                    isAvailable={food.isAvailable}
                    description={food.description}
                    price={formatPrice(food.price)}
                    onClick={() => handleOpen(food)}
                    amountInBasket={countAmountInBasket(basketOrders, food.id)}
                  />
                );
              })}
            </SimpleGrid>
          </Box>
        );
      })}
    </Box>
  );
}

export default FoodMenu;
